module.exports = __webpack_public_path__ + "static/media/settings_room_device_doorbell.26087b6e.svg";